export enum ProductId {
  WhiteGlove = "white-glove",
  WhiteGlovePlus = "white-glove-f409a",
  F409A = "f409a",
  CapTable = "cap-table",
}

export enum TierId {
  WhiteGlove = "white-glove",
  WhiteGlovePlus = "white-glove-f409a",
  F409A = "f409a",
  CapTable = "cap-table",
}

export enum PlanId {
  Launch = "launch",
  Growth = "growth",
  Scale = "scale",
}

export type MetaData = {
  name: string;
  level: string;
  type: string;
}

export type Tier = {
  id: TierId;
  name: string;
  price: number;
  stripePriceId: string;
  off?: number;
  benefits?: string[];
  items?: {
    [tierId in TierId]: { id: TierId; name: string; benefits: string[] };
  };
  metadata?: MetaData;
};

export type Plan = {
  id: PlanId;
  revenue: string;

  tiers: {
    [tierId in TierId]: Tier;
  };
};

export type Product = {
  id: ProductId;
  plans: {
    [planId in PlanId]: Plan;
  };
};
